import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { TipoProduto } from "src/app/core/enums/produto.enum";
import { ListaResultset } from "src/app/core/list/lista-resultset.interface";
import { Equipamento } from "src/app/farmacia/produto/equipamento/equipamento.model";
import { EquipamentoService } from "src/app/farmacia/produto/equipamento/equipamento.service";
import { Material } from "src/app/farmacia/produto/material/material.model";
import { MaterialService } from "src/app/farmacia/produto/material/material.service";
import { Medicamento } from "src/app/farmacia/produto/medicamento/medicamento.model";
import { MedicamentoService } from "src/app/farmacia/produto/medicamento/medicamento.service";
import { Produto } from "src/app/farmacia/produto/produto/produto.model";
import { IProdutoComLabel } from "../autocomplete-produto.component";
import { ProdutoFilter } from "src/app/farmacia/produto/produto/produto.filter";

export class AutocompleteProdutoUtil {

  public addExtraFilter(filtroOriginal: ProdutoFilter, filtroExtra: ProdutoFilter): ProdutoFilter {
    try {
      if ( filtroExtra ) {
        Object.entries(filtroExtra)
              .forEach(e => {
                const keyFiltroExtra   = e[0];
                const valueFiltroExtra = e[1];

                filtroOriginal[keyFiltroExtra] = valueFiltroExtra;
              });
      }
    }
    catch(e) { console.error(e); }

    return filtroOriginal;
  }

  public removeExtraFilter(filtroOriginal: ProdutoFilter, chaveARemover: string): ProdutoFilter {
    try {
      if ( chaveARemover ) {
        delete filtroOriginal[chaveARemover];
      }
    }
    catch(e) { console.error(e); }

    return filtroOriginal;
  }

  public getExtraFilterRepository(repository: 'ESTOQUE' | 'INVENTARIO' | 'INVENTARIO_ESTOQUE'): ProdutoFilter {
    if ( repository ) {
      const filter: ProdutoFilter = {
        validoEmEstoque            : false,
        validoEmInventario         : false,
        validoEmEstoqueOuInventario: false
      }

      switch (repository) {
        case "ESTOQUE":
          filter.validoEmEstoque = true;
          break;

        case "INVENTARIO":
          filter.validoEmInventario = true;
          break;

        case "INVENTARIO_ESTOQUE":
          filter.validoEmEstoqueOuInventario = true;
          break;
      }

      return filter;
    }

    return null;
  }


  searchProduto( tipoProdutoSelecionado: TipoProduto
                ,filter: ProdutoFilter
                ,materialService: MaterialService
                ,medicamentoService: MedicamentoService
                ,equipamentoService: EquipamentoService
              ): Observable<IProdutoComLabel[]> {

    switch (tipoProdutoSelecionado) {
      case TipoProduto.MEDICAMENTO.toString():
        return medicamentoService.listar(filter)
            .pipe(
              map((response: ListaResultset<Medicamento>) => this.montaStringAutocomplete(TipoProduto.MEDICAMENTO, response.content))
            );

      case TipoProduto.MATERIAL.toString():
        return materialService.listar(filter)
            .pipe(
              map((response: ListaResultset<Material>) => this.montaStringAutocomplete(TipoProduto.MATERIAL, response.content))
            );

      case TipoProduto.EQUIPAMENTO.toString():
        return equipamentoService.listar(filter)
            .pipe(
              map((response: ListaResultset<Equipamento>) => this.montaStringAutocomplete(TipoProduto.EQUIPAMENTO, response.content))
            );

      default:
        console.error('Autocomplete Produto UTIL :: Tipo de Produto não informado corretamente.');
        return null;
    }
  }

  private montaStringAutocomplete(tipoProduto: TipoProduto, produtos: Produto[]): IProdutoComLabel[] {
    if (!produtos) {
        return null;
    }
    const stringProdutos = new Array<IProdutoComLabel>();
    let o: string;
    for (const produto of produtos) {
      o = '';
      if (produto.idExterno) {
          o += produto.idExterno;
      }
      if (produto.descricao) {
          if (o) {
              o += ' - ';
          }
          o += produto.descricao;
      }
      if (produto.tuss) {
          if (o) {
              o += ' - ';
          }
          o += produto.tuss;
      }

      stringProdutos.push({label: o, produto: produto});
    }
    return stringProdutos;
  }

}
